export default "__VITE_ASSET__pSWqPKV9__"